import InsurerLogo from "./InsurerLogo";
import NormalText from "./NormalText";
import { useDispatch, useSelector } from "react-redux";
import {
  getInsurerNameFromCode,
  getInsurerEmailsFromCode,
} from "../store/quotes";
import { getBrokerInformation } from "../store/broker";
import * as theme from "../theme";
import SelectEmail from "./SelectEmail";
import StarRating from "./StarRating";
import IncludanceAndSelection from "./IncludanceAndSelection";
import { changeHelpOrTipText } from "../store/components";
import translations from "../utils/translations";

const InsurerRow = (props) => {
  const { code, stiColoumnWidth } = props;

  const insurername = useSelector(getInsurerNameFromCode({ code }));
  const emails = useSelector(getInsurerEmailsFromCode({ code }));
  const brokerInfo = useSelector(getBrokerInformation);
  const languagepreference = brokerInfo.information.languagepreference;

  const selected = useSelector(
    (state) => state.entities.quotes.insurerdetails[code].selected
  );

  const starrating = useSelector(
    (state) => state.entities.quotes.insurerdetails[code].starrating
  );

  const numberofratings = useSelector(
    (state) => state.entities.quotes.insurerdetails[code].numberofratings
  );

  const dispatch = useDispatch();

  const commonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "7vh",
        maxHeight: 75,
        borderBottom: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        borderTop: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        backgroundColor: selected
          ? theme.COLORS.tertiary_ligthindigo
          : theme.COLORS.help_tip,
      }}
    >
      <div
        style={{
          ...commonStyle,
          width: stiColoumnWidth.first,
        }}
      >
        <div style={{ height: "70%" }}>
          <InsurerLogo code={code}></InsurerLogo>
        </div>
      </div>

      <div
        style={{
          ...commonStyle,
          width: stiColoumnWidth.second,
          textAlign: "center",
        }}
      >
        <NormalText
          text={insurername}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText>
      </div>

      <div style={{ ...commonStyle, width: stiColoumnWidth.third }}>
        <div
          style={{
            width: "100%",
            height: "60%",
            display: "flex",
            paddingRight: "10px",
            paddingLeft: "10px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SelectEmail key={code} code={code} emails={emails}></SelectEmail>
        </div>
      </div>

      <div style={{ ...commonStyle, width: stiColoumnWidth.fourth }}>
        <div
          style={{
            width: "100%",
            height: "60%",
            display: "flex",
            paddingRight: "10px",
            paddingLeft: "10px",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
          onMouseOver={() => {
            dispatch(
              changeHelpOrTipText(
                `${starrating} ${translations[languagepreference].stars} ${translations[languagepreference].basedOn} ${numberofratings} ${translations[languagepreference].reviewsText}`
              )
            );
          }}
          onMouseOut={() => {
            dispatch(changeHelpOrTipText(""));
          }}
        >
          <StarRating readonly={true} starrating={starrating}></StarRating>
        </div>
      </div>

      <div style={{ ...commonStyle, width: stiColoumnWidth.fifth }}>
        <IncludanceAndSelection key={code} code={code}></IncludanceAndSelection>
      </div>
    </div>
  );
};

export default InsurerRow;
